import type { McpIssueDay } from "@/lib/api";

/** Share of its band a bar fills, per the figure style (about 65%). */
const BAR_SHARE = 0.65;

/** The sparkline's drawing box: one unit per day wide, 20 high. */
const HEIGHT = 20;

/**
 * An issue's failures per day of the period as a row of small bars in De
 * Ceuster blauw, on a baseline, scaled to its busiest day: at a glance,
 * whether it failed once, steadily or in a burst. Decorative (`aria-hidden`):
 * the row says the count, and the issue's page has the chart.
 */
export function Sparkline({ days }: { days: readonly McpIssueDay[] }) {
  const max = Math.max(1, ...days.map((day) => day.count));
  const width = Math.max(1, days.length);
  return (
    <svg
      aria-hidden="true"
      viewBox={`0 0 ${width} ${HEIGHT}`}
      preserveAspectRatio="none"
      className="h-5 w-24"
    >
      <line
        x1={0}
        x2={width}
        y1={HEIGHT}
        y2={HEIGHT}
        strokeWidth={2}
        vectorEffect="non-scaling-stroke"
        className="stroke-border"
      />
      {days.map((day, index) => {
        const height = (day.count / max) * (HEIGHT - 1);
        return (
          day.count > 0 && (
            <rect
              key={day.day}
              x={index + (1 - BAR_SHARE) / 2}
              width={BAR_SHARE}
              y={HEIGHT - height}
              height={height}
              className="fill-chart-1"
            />
          )
        );
      })}
    </svg>
  );
}
